<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M21.5821 7.19053C21.3521 6.32829 20.6744 5.64921 19.8139 5.41876C18.2542 5 12 5 12 5C12 5 5.74586 5 4.18613 5.41876C3.32565 5.64925 2.64794 6.32829 2.41792 7.19053C2 8.75339 2 12.0141 2 12.0141C2 12.0141 2 15.2749 2.41792 16.8378C2.64794 17.7 3.32565 18.3508 4.18613 18.5812C5.74586 19 12 19 12 19C12 19 18.2541 19 19.8139 18.5812C20.6744 18.3508 21.3521 17.7 21.5821 16.8378C22 15.2749 22 12.0141 22 12.0141C22 12.0141 22 8.75339 21.5821 7.19053ZM9.95453 14.9747V9.05362L15.1818 12.0142L9.95453 14.9747Z"
    />
  </svg>
</template>
